import React from "react";

function Rating() {
  return (
    <section className="py-5 bg-primary text-white">
      <div className="container">
        <div className="row text-center gy-4">

          <div className="col-12 col-md-3">
            <i className="bi bi-gear fs-1 mb-2"></i>
            <h2 className="fw-bold">15+</h2>
            <p className="text-uppercase small mb-0">
              Years in Industrial Supply
            </p>
          </div>

          <div className="col-12 col-md-3">
            <i className="bi bi-box-seam fs-1 mb-2"></i>
            <h2 className="fw-bold">12k+</h2>
            <p className="text-uppercase small mb-0">
              Orders Delivered
            </p>
          </div>

          <div className="col-12 col-md-3">
            <i className="bi bi-lightning-charge fs-1 mb-2"></i>
            <h2 className="fw-bold">8k+</h2>
            <p className="text-uppercase small mb-0">
              Happy Business Clients
            </p>
          </div>

          <div className="col-12 col-md-3">
            <i className="bi bi-building fs-1 mb-2"></i>
            <h2 className="fw-bold">30+</h2>
            <p className="text-uppercase small mb-0">
              Partner Industries
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Rating;
